import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SNModalService } from '@web-services/modal/snModal.service';

@Component({
	selector: 'save-new-template',
	template: require('./save-new-template-modal.component.html'),
	styles: [require('./save-new-template-modal.component.scss')]
})
export class SaveNewTemplateModalComponent {
	@Input() templateTypeName: string;
	@Input() templateNameTitle: string;
	@Input() btnDisable: boolean;
	@Input() breadcrumbsText: string;
	@Input() templateNameProp: string;
	templateName: string;

	constructor(
		private activeModal: NgbActiveModal,
		private modalService: SNModalService
	) {}

	ngOnInit(): void {
		this.templateName = this.templateNameProp
			? `${this.templateNameProp} copy`
			: '';
	}

	onDismiss(): void {
		this.modalService.setModalData({ action: 'CLOSE', props: null });
	}

	saveNewTemplate(): void {
		this.modalService.setModalData({
			action: 'SAVE',
			props: this.templateName
		});
	}

	changeTemplateName(name: string): void {
		this.templateName = name;
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/quotes/modals/save-new-template-modal/save-new-template-modal.component.ts